import { ReactComponent as Opened } from "../../../styles/icon/opened.svg"
import { ReactComponent as Closed } from "../../../styles/icon/closed.svg"
import { ReactComponent as Add } from "../../../styles/icon/add.svg"
import { ReactComponent as NextPageGrey } from "../../../styles/icon/right_arrow.svg"
import { ReactComponent as PreviousPageGrey } from "../../../styles/icon/left_arrow.svg"
import { ReactComponent as Search } from "../../../styles/icon/search.svg"
import { ReactComponent as Filter } from "../../../styles/icon/filter.svg"
import { ReactComponent as Plus } from "../../../styles/icon/plus.svg"
import { ReactComponent as MobileItemClosed } from "../../../styles/icon/mobileItemClosed.svg"
import { ReactComponent as MobileItemOpened } from "../../../styles/icon/mobileItemOpened.svg"
import { ReactComponent as MobileItemDelete } from "../../../styles/icon/mobileItemDelete.svg"
import { ReactComponent as MobileItemAccept } from "../../../styles/icon/mobileItemAccept.svg"
import { ReactComponent as MobileItemDecline } from "../../../styles/icon/mobileItemDecline.svg"
import { ReactComponent as MobileQuestionMark } from "../../../styles/icon/question_mark.svg"
import { ReactComponent as SortInactive } from "../../../styles/icon/sortInactive.svg"
import { ReactComponent as SortActive } from "../../../styles/icon/sortActive.svg"
import { ReactComponent as NoData} from "../../../styles/icon/noData.svg"
import styled from "styled-components";

export const ClosedIcon = styled(Closed)`
  height: 10px;
  width: 10px;
`;
export const OpenedIcon = styled(Opened)`
  height: 10px;
  width: 10px;
`;
export const AddIcon = styled(Add)`
  margin-right: 10px;
  height: 10px;
  width: 10px;
`;
export const MenuArrowIcon = styled(NextPageGrey)`
  height: 15px;
  width: 15px;
  padding-right:24px;
  float: right;
`;
export const InfoBoxArrowIconClose = styled(PreviousPageGrey)`
  margin-top: -7px;
  height: 13px;
  width: 13px;
  padding-right: 5px;
  fill: ${props => props.theme.brandColor1};
  right: 0px;
  top: 50%;
  position: absolute;
  cursor: pointer;
  `;
  export const InfoBoxArrowIconOpen = styled(NextPageGrey)`
  margin-top: -7px;
  height: 13px;
  width: 13px;
  padding-right: 5px;
  fill: ${props => props.theme.brandColor1};
  right: 0px;
  top: 50%;
  position: absolute;
  cursor: pointer;
  `;
export const SearchIcon = styled(Search)`
  height: 15px;
  width: 15px;
  position: absolute;
  top: 6px;
  right: 15px;
  pointer-events: none;
  > path {
    fill: ${props => props.theme.brandColor1};
  }
`;
export const FilterIcon = styled(Filter)`
  height: 15px;
  width: 15px;
  position: absolute;
  top: 7px;
  right: 20px;
  pointer-events: none;
`;
export const PlusIcon = styled(Plus)`
  height: 15px;
  width: 15px;
  position: absolute;
  top: 7px;
  right: 20px;
  pointer-events: none;
`;
export const MobileItemClosedIcon = styled(MobileItemClosed)`
  height: 24px;
  width: 24px;
  > circle {
    fill: ${props => props.theme.brandColor1}
  }
`;
export const MobileItemOpenedIcon = styled(MobileItemOpened)`
  height: 24px;
  width: 24px;
  > circle {
    fill: ${props => props.theme.brandColor1}
  }
`;
export const MobileItemDeleteIcon = styled(MobileItemDelete)`
  height: 24px;
  width: 24px;
`;
export const MobileItemAcceptIcon = styled(MobileItemAccept)`
  height: 24px;
  width: 24px;
  padding-right: 15px;
`;
export const MobileItemDeclineIcon = styled(MobileItemDecline)`
  height: 24px;
  width: 24px;
`;

export const MobileQuestionMarkIcon = styled(MobileQuestionMark)`
  height: 30px;
  width: 11px;
`;
export const SortInactiveIcon = styled(SortInactive)`
  height: 13px;
  width: 13px;
  padding-right: 5px;
`;
export const SortActiveIcon = styled(SortActive)`
  height: 13px;
  width: 13px;
  padding-right:5px;
`;
export const NoDataIcon= styled(NoData)`
  @media screen and (min-width: ${props => props.theme.mobileTableBreakPoint}px) {
    margin-left: -50px;
    height: 82px;
    width: 80.65px;
    padding-right: 5px;
    top: 60px;
    position: relative;
  },
  > path.theme {
    fill: ${props => props.theme.brandColor1}
  }
`;